const React = require('react');
const VoiceWidgets = require('./src/components/voice-widgets').VoiceWidgets;
const Link = require('gatsby').Link;
const Navigation = require('./src/components/navigation/navigation').Navigation;

exports.wrapPageElement = ({ element }) => {
  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <Navigation />
        <VoiceWidgets />
        {element}
      </div>
      <footer>
        <div>© {new Date().getFullYear()} K9 Kommando</div>
        <ul>
          <li>
            <Link to="/impressum">Impressum und Datenschutz</Link>
          </li>
        </ul>
      </footer>
    </>
  );
};
